import React,{useEffect,useState} from 'react';
import styled from 'styled-components';
import { AppState } from '../../store';
import { withRouter, useHistory } from 'react-router';
import { connect } from 'react-redux';
import { setCurrentCategory, setSubCategoriesStatus,getCategory } from '../../store/categories/functions';
import { fetchFormData, finder } from '../../store/forms/functions';
import { FormData,Form } from '../../store/forms/types';
import {DynamicForm, Card, CardActionButton} from './../elements'
import { putFormDataItem } from '../../store/forms/functions';
import { CONSTS } from '../elements/_constants';
type FormItemEditComponentProps = {
    className?: string,
    match: any,
    onToggleSubCategories: Function,
    onPutFormData: Function,
    onFetchFormData: Function,
    currentCategoryId: number,
    currentCategory: any,
    categories: any,
    currentFormData?: FormData,
    currentForm?: Form
}

const FormItemEditComponent = (props: FormItemEditComponentProps) => {
  const [fields, setFields] = useState<FormData>();
  let history = useHistory();
  useEffect(() => {
    props.onFetchFormData(parseInt(""+props.match.params.itemId),parseInt(""+props.match.params.formId));
    return () => {};
  }, [])
  useEffect(() => {
    resetForm();
    return () => {};
  }, [props.currentFormData])

  const resetForm = ()=> {
    if(props.currentFormData) {
        setFields(props.currentFormData);
    }
  }
    return (
        <div className={props.className}>
          {props.currentForm &&
            <Card
              title={props.currentForm.title+": مورد "+props.match.params.itemId}
              headerMeta={<>
                <CardActionButton title="بازگشت" to={props.match.url.substring(0, props.match.url.lastIndexOf("/"))} iconClassName="icon-icons8-cancel" hasBorderRight={true}/>
              </>}
            >
                {fields && <DynamicForm onSubmit={(data: any)=>props.onPutFormData(parseInt(""+props.match.params.itemId),parseInt(""+props.match.params.formId),data,()=>{
                    history.push(history.location.pathname.substring(0, history.location.pathname.lastIndexOf("/")))
                })} isEdit={true} fields={fields.items}/>}
            </Card> 
          }
        </div>
    )
}

const FormItemEdit = styled(FormItemEditComponent)`
` 

const mapStateToProps = (state: AppState,ownProps: any) => ({
  categories: state.categories,
  currentCategory: getCategory(state.categories.items,state.categories.currentCategoryId),
  currentCategoryId: state.categories.currentCategoryId,
  currentFormData: findFormData(ownProps.match.params.formId,ownProps.match.params.itemId,state.forms.forms),
  currentForm: findForm(ownProps.match.params.formId,state.forms.forms),
});
function findForm(formId: any,forms: Form[]) {
  if(!formId || !forms) return;
  let formIndex = finder(parseInt(""+formId),forms);
  return forms[formIndex];
}
function findFormData(formId: any,itemId: any,forms: Form[]) {
  if(!formId || !itemId || !forms) return;
  let formIndex = finder(parseInt(""+formId),forms);
  if(formIndex == -1) return;
  let formDataIndex = finder(parseInt(""+itemId),forms[formIndex].formDatas);
  if(formDataIndex == -1) return;
  return forms[formIndex].formDatas[formDataIndex];
}
const mapDispatchToProps = (dispatch:any) => {
    return {
      onToggleSubCategories   : (open: boolean)   =>{
        dispatch(setSubCategoriesStatus(open));
      },
      onFetchFormData: (id: number, formId: number)=>{
        dispatch(fetchFormData(id,formId))
      },
      onPutFormData: (id: number,formId: number,formData: any,then: Function) => {
        dispatch(putFormDataItem(id,formId,formData,then))
      }
    };
  };
  
  export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(FormItemEdit));
